export default __webpack_public_path__ + "static/media/icon-success.c69aff81.svg";